import { useState } from "react";
import { Eye, EyeOff, ExternalLink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const SecretField = ({ id, label, help, helpUrl, settings, value, onChange, onClear }) => {
  const [visible, setVisible] = useState(false);
  const isSet = settings?.[`${id}_set`];
  return (
    <div className="grid gap-3 border-b border-border py-5 last:border-0 md:grid-cols-[220px_1fr]">
      <div>
        <Label htmlFor={id} className="font-semibold">{label}</Label>
        <div data-testid={`${id}-status`} className={`mt-1 text-xs font-semibold ${isSet ? "text-emerald-700" : "text-amber-700"}`}>
          {isSet ? `Configurée · ${settings[`${id}_preview`]}` : "Non configurée"}
        </div>
      </div>
      <div>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Input
              id={id}
              data-testid={`${id}-input`}
              type={visible ? "text" : "password"}
              autoComplete="off"
              placeholder={isSet ? "Saisir une nouvelle clé pour remplacer" : "Collez votre clé API"}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="pr-10 font-mono"
            />
            <button type="button" onClick={() => setVisible((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground" data-testid={`${id}-toggle-visibility`}>
              {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
          {isSet && <Button type="button" variant="outline" data-testid={`${id}-clear-button`} onClick={onClear}>Retirer</Button>}
        </div>
        <p className="mt-2 text-xs text-muted-foreground">
          {help}{" "}
          {helpUrl && <a href={helpUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-0.5 text-[#002FA7] hover:underline">Obtenir la clé <ExternalLink className="h-3 w-3" /></a>}
        </p>
      </div>
    </div>
  );
};
